import { useRef, useEffect } from 'react';

function BarcodePreview({ value, width = 1.6, height = 45, fontSize = 12, sideText }) {
  const svgRef = useRef(null);
  useEffect(() => {
    if (svgRef.current && value) {
      let alive = true;
      // jsbarcode (~60 kB) is only needed where a barcode is actually drawn,
      // so it is fetched on demand instead of riding on first paint.
      import('jsbarcode')
        .then(({ default: JsBarcode }) => {
          if (!alive || !svgRef.current) return;
          try {
            JsBarcode(svgRef.current, value, {
              format: 'CODE128',
              width,
              height,
              fontSize,
              displayValue: true,
              background: '#ffffff',
              lineColor: '#000000',
              margin: 2,
            });
          } catch {
            if (svgRef.current) svgRef.current.innerHTML = '';
          }
        })
        .catch(() => {
          if (alive && svgRef.current) svgRef.current.innerHTML = '';
        });
      return () => { alive = false; };
    }
    return undefined;
  }, [value, width, height, fontSize]);
  if (!value) return null;
  if (sideText) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', maxWidth: '100%', boxSizing: 'border-box', margin: '0 auto' }}>
        <div style={{ flex: '1 1 auto', minWidth: 0, display: 'flex', justifyContent: 'center', overflow: 'hidden' }}>
          <svg ref={svgRef} style={{ maxWidth: '100%', height: 'auto', display: 'block' }} />
        </div>
        <div style={{
          writingMode: 'vertical-rl',
          textOrientation: 'mixed',
          fontWeight: 700,
          fontSize: '12px',
          color: '#09090b',
          letterSpacing: '0.5px',
          whiteSpace: 'nowrap',
          flexShrink: 0,
          paddingLeft: '6px',
          borderLeft: '1px dashed #cbd5e1',
          lineHeight: 1
        }}>
          {sideText}
        </div>
      </div>
    );
  }
  return <svg ref={svgRef} style={{ maxWidth: '100%', height: 'auto', display: 'block', margin: '0 auto' }} />;
}

export default BarcodePreview;
